// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__B2ZBA","loaderOuter":"PageOverlayLoader_loaderOuter__2xidA"};